import { configureHandler } from './handler'

export function configureInternal(queryName: string) {
  return configureHandler(queryName)
}
